import { HttpClient } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { RaghuserviceService } from '../raghuservice.service';
declare var $:any 
import Swal from 'sweetalert2';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
// import { DomSanitizer } from '@angular/platform-browser'
// import { PipeTransform, Pipe } from "@angular/core";


@Component({
  selector: 'app-ereader',
  templateUrl: './ereader.component.html',
  styleUrls: ['./ereader.component.css']
})

export class EreaderComponent implements OnInit {

  chapters:any = []


  constructor(private dom:DomSanitizer, private routes:ActivatedRoute, private service:RaghuserviceService, private http:HttpClient) { }
  data : any
  raghuData : any = []
  

  slokaAnalysis : any = []
  compAna :any = []

  allLinks:any = []
  samAsaApiLink:any
  ngOnInit(): void {
    // this.routes.paramMap.subscribe( para => {
    //   this.data = para.get('chaptno')
      
    //   this.service.readRaghuApi().subscribe( data => {
    //     this.raghuData = data
        
    //     for(let allData of this.raghuData){
    //         if(allData.chaptno == this.data){
    //             this.texts.push(allData)
    //         }
    //     }

    //   })
    // })

    this.http.get('assets/data/apienv.json').subscribe(link => {
      this.allLinks= link
      for(let item of this.allLinks){
        this.samAsaApiLink = item.samasagraphapi
      }
    })

    this.http.get('assets/data/chapters.json').subscribe( chpt => {
      this.chapters = chpt
    })

    this.service.readRaghuApi().subscribe( data => {
      this.raghuData = data
    })


    this.service.readAnalysis().subscribe( analysis =>{
      this.compAna = analysis
    })

    $(document).ready(function(){
      $('.modal').modal();
      $('.materialboxed').materialbox();
      $('.tabs').tabs(
        {
          swipeable: true,
          responsiveThreshold	:Infinity
        }
      );

    });


    

  }

  texts : any = []
  getSlokas(chapterno:any){
    this.texts = []
    this.shwAna = false
    this.shwGraf = false
    // this.service.readRaghuApi().subscribe( data => {
    //   this.raghuData = data
      
      for(let allData of this.raghuData){
          if(allData.chaptno == chapterno){
              this.texts.push(allData)
              // this.makeCorpus(chapterno,allData.slokano)
          }
      }
  }


corpus:any = []
tt : any
makeCorpus(chaptNo:any, slokaNo:any){
  // console.log(this.compAna)
  let analy = ""
  for(let ana of this.compAna){
      if(ana.chpatno == chaptNo && ana.slokano == slokaNo){
        analy += ana.word+"/"+ana.morph_in_context+" "
         // var newana = ana.morph_in_context.replaceAll("{","_")
          // newana = newana.replaceAll("}","_")
          // newana = newana.replaceAll(";","_")
      }
      // console.log(ana)
  }
  var cc = {
    "chaptno":chaptNo,
    "slokano":slokaNo,
    "morphd" : analy
  }
  console.log(analy)
  this.corpus.push(cc)
  // this.tt = analy
  // console.log(this.corpus)
}

  shwAna = false
  showAnalysis : any = []

  sentOneAna:any = []
  sentTwoAna:any = []
  sentThreeAna :any = []
  sentFourAna:any = []
  sentFiveAna:any = []
  sentSixAna :any = []
  sentSevenAna :any = []

  sentOneAAna :any = []
  sentOneBAna :any = []
  sentTwoAAna :any = []
  sentTwoBAna :any = []


  chapterNo : any
  slokaNo:any
  shwGraf:any 

  sentOneGraf:any
  sentTwoGraf:any
  sentThreeGraf:any
  sentFourGraf:any
  sentFiveGraf:any
  sentSixGraf:any
  sentSevenGraf:any

  sentOneAGraf:any
  sentOneBGraf:any
  sentTwoAGraf:any
  sentTwoBGraf:any

  sentOneStat :any 
  sentTwoStat :any 
  sentThreeStat :any
  sentFourStat :any 
  sentFiveStat :any 
  sentSixStat :any
  sentSevenStat : any

  sentOneAStat : any
  sentOneBStat : any
  sentTwoAStat : any
  sentTwoBStat : any

  getAnalysis(chaptno:any, slokano:any){
   
    this.chapterNo = chaptno
    this.slokaNo = slokano
    // alert(chaptno+","+slokano)
    
    this.showAnalysis = []
    this.sentOneAna = []
    this.sentTwoAna = []
    this.sentThreeAna = []
    this.sentFourAna = []
    this.sentFiveAna = []
    this.sentSixAna = []
    this.sentSevenAna = []

  this.sentOneAAna = []
  this.sentOneBAna = []
  this.sentTwoAAna  = []
  this.sentTwoBAna = []

    this.sentOneGraf = ""
    this.sentTwoGraf = ""
    this.sentThreeGraf = ""
    this.sentFourGraf = ""
    this.sentFiveGraf = ""
    this.sentSixGraf = ""
    this.sentSevenGraf = ""
    this.sentOneAGraf = ""
    this.sentOneBGraf = ""
    this.sentTwoAGraf = ""
    this.sentTwoBGraf = ""


    this.sentOneStat  = ""
    this.sentTwoStat  = "" 
    this.sentThreeStat = "" 
    this.sentFourStat  = ""
    this.sentFiveStat  = "" 
    this.sentSixStat = "" 
    this.sentSevenStat = ""
    this.sentOneAStat = ""
    this.sentOneBStat = ""
    this.sentTwoAStat = ""
    this.sentTwoBStat = ""

    for(let singAna of this.compAna){
                    this.showAnalysis = []
      
      if(singAna.chpatno == chaptno && singAna.slokano == slokano){
        
        // this.showAnalysis.push(singAna)
        
            if(singAna.sentno == "1"){
              // this.showAnalysis.push(singAna)
              this.sentOneAna.push(singAna)
              this.sentOneGraf = singAna.graph
              this.sentOneStat = "yes"
            }else if(singAna.sentno == "2"){
              // this.showAnalysis.push(singAna)
              this.sentTwoAna.push(singAna)
              this.sentTwoGraf = singAna.graph
              this.sentTwoStat = "yes"
            }else if(singAna.sentno == "3"){
              // this.showAnalysis.push(singAna)
              this.sentThreeAna.push(singAna)
              this.sentThreeGraf = singAna.graph
              this.sentThreeStat = "yes"
            }else if(singAna.sentno == "4"){
              // this.showAnalysis.push(singAna)
              this.sentFourAna.push(singAna)
              this.sentFourGraf = singAna.graph
              this.sentFourStat = "yes"
            }  else if(singAna.sentno == "5"){
              // this.showAnalysis.push(singAna)
              this.sentFiveAna.push(singAna)
              this.sentFiveGraf = singAna.graph
              this.sentFiveStat = "yes"
            }  else if(singAna.sentno == "6"){
              // this.showAnalysis.push(singAna)
              this.sentSixAna.push(singAna)
              this.sentSixGraf = singAna.graph
              this.sentSixStat = "yes"
            }  else if(singAna.sentno == "7"){
              // this.showAnalysis.push(singAna)
              this.sentSevenAna.push(singAna)
              this.sentSevenGraf = singAna.graph
              this.sentSevenStat = "yes"
            }       
            else if(singAna.sentno == "1a"){
              // this.showAnalysis.push(singAna)
              this.sentOneAAna.push(singAna)
              this.sentOneAGraf = singAna.graph
              this.sentOneAStat = "yes"
            }  
            else if(singAna.sentno == "1b"){
              // this.showAnalysis.push(singAna)
              this.sentOneBAna.push(singAna)
              this.sentOneBGraf = singAna.graph
              this.sentOneBStat = "yes"
            } else if(singAna.sentno == "2a"){
              // this.showAnalysis.push(singAna)
              this.sentTwoAAna.push(singAna)
              this.sentTwoAGraf = singAna.graph
              this.sentTwoAStat = "yes"
            } else if(singAna.sentno == "2b"){
              // this.showAnalysis.push(singAna)
              this.sentTwoBAna.push(singAna)
              this.sentTwoBGraf = singAna.graph
              this.sentTwoBStat = "yes"
            }  
      }
    }
    

    if(this.sentOneStat == ""){
      Swal.fire({
        text:"The Anlysis Not Found for this Sloka!",
        icon:'info'
      })
      this.shwAna = false
    }else{
      this.shwAna = true
      this.shwGraf = false
    }

  }

  grafLink : any
  show(){
    console.log("hi")
  }

  grafLinkOne:any
  grafLinkTwo:any
  grafLinkThree:any

  showGraf(grafPath:any){
    this.grafLink =""
    
    this.grafLink = grafPath
    this.shwGraf = true
  }

  
  showDict(){
    // $(function(){
      $.ajax({
          type: 'GET',
          url: "http://localhost/palischolars/api/palischolars/test.php",    
          crossDomain: true,
          dataType: 'jsonp',   
          succces: function(data:any){
              // console.log('success',data);   
              $("#div1").html(data); 
              // alert(data)             
          }
      });
  // });
    
   

  }




  graph : any
  compGraphLink : any 
  svgTemplate : any
  compInput : any 
  createGraph(input:any){
    this.compGraphLink = ""
    // alert(input)
    this.service.createGraph(input, this.samAsaApiLink).subscribe(results => {
        this.graph = results
        this.svgTemplate = this.dom.bypassSecurityTrustHtml(results);
        this.compInput = input
        // console.log(this.svgTemplate)
        // console.log(this.graph)
        // this.compGraphLink = 'http://sanskrit.uohyd.ac.in:8080/dotapi/jpgfiles/'+input+'.jpg'
        // Swal.fire({
        //   title: input,
        //   html:'<div [ngStyle]="{\'background-image\':\'url('+this.svgTemplate+')\'}"></div>'
        // })
    })
  }

  addDict(ana:any){
      var analysis = ana.split('{')
      alert(analysis[0])
  }


  feat:any 
  stem:any
  getFeat(ana:any){
    this.feat = ""
    // this.stem = ""
    var analysis = ana.split('{')
    // this.stem = analysis[0]
    this.feat = analysis[1]
    var count = 0
    for(let k of analysis){
      if(count > 1){
      this.feat += "{"+k
      }
      count = count + 1
    }
    // this.getStem2(ana)
    return this.feat
  }


  getStem(ana:any){
    var analysis = ana.split('{')
    this.stem = analysis[0]
    return this.stem
  }
 
  stems: any = []
  getStem2(ana:any){
    this.stems = []
    var analysis = ana.split('{')
    this.stem = analysis[0]
    if(this.stem.match("-")){
      var stems = this.stem.split("-")
      for(let sst of stems){
        var arr = {"stem": sst}
        this.stems.push(arr)
      }
    }else{
      var arr = {"stem": this.stem}
        this.stems.push(arr)
    }
    // return this.stem
    console.log(this.stems)
  }
 

  res:any 
  getDict(stem:any){
    this.service.getDict(stem).subscribe(results => {
      console.log(results)
      this.res = results
    })
  }


}
